import { assertUnreachable, LanguageEnum } from '@luminovo/commons';
import {
    CzechFlagIcon,
    DutchFlagIcon,
    FinnishFlagIcon,
    FrenchFlagIcon,
    GermanFlagIcon,
    HalfPortugalHalfBrazilFlagIcon,
    HalfUSHalfBritishFlagIcon,
    HungarianFlagIcon,
    IndianFlagIcon,
    ItalianFlagIcon,
    JapaneseFlagIcon,
    NeutralLanguageIcon,
    PolishFlagIcon,
    SpanishFlagIcon,
    SwedishFlagIcon,
    ThaiFlagIcon,
    TurkishFlagIcon,
} from '@luminovo/design-system';

export function getIconForLanguage(language: LanguageEnum, props?: React.SVGProps<SVGSVGElement>) {
    switch (language) {
        case 'en':
            return <HalfUSHalfBritishFlagIcon {...props} />;
        case 'de':
            return <GermanFlagIcon {...props} />;
        case 'fr':
            return <FrenchFlagIcon {...props} />;
        case 'es':
            return <SpanishFlagIcon {...props} />;
        case 'it':
            return <ItalianFlagIcon {...props} />;
        case 'th':
            return <ThaiFlagIcon {...props} />;
        case 'ja':
            return <JapaneseFlagIcon {...props} />;
        case 'hi':
            return <IndianFlagIcon {...props} />;
        case 'cs':
            return <CzechFlagIcon {...props} />;
        case 'nl':
            return <DutchFlagIcon {...props} />;
        case 'hu':
            return <HungarianFlagIcon {...props} />;
        case 'fi':
            return <FinnishFlagIcon {...props} />;
        case 'sv':
            return <SwedishFlagIcon {...props} />;
        case 'pl':
            return <PolishFlagIcon {...props} />;
        case 'tr':
            return <TurkishFlagIcon {...props} />;
        case 'pt':
            return <HalfPortugalHalfBrazilFlagIcon {...props} />;
        // Politically ambiguous: a national flag would be misleading, so use a neutral globe.
        case 'zh':
            return <NeutralLanguageIcon {...props} />;
        default:
            assertUnreachable(language);
    }
}
